'use strict';
var $ = require('jquery');

module.exports = {
	scrollToOriginalPosition: function (element) {
			var scrollDistance = $(element).scrollTop();
			$(element).scrollTop(scrollDistance);
			$('body').scrollTop(0);
	}
};